import { styled } from 'styled-system/jsx'

const Section = styled('section', {
  base: {
    paddingY: { base: '64px', md: '96px' },
    paddingX: { base: '16px', md: '32px' },
    background:
      'linear-gradient(135deg, var(--colors-book-primary) 0%, #0E3FB6 100%)',
    color: '#fff',
  },
})

const Inner = styled('div', {
  base: {
    maxWidth: '780px',
    margin: '0 auto',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
  },
})

const Eyebrow = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: 600,
    color: 'rgba(255, 255, 255, 0.78)',
    textTransform: 'uppercase',
    letterSpacing: '0.12em',
  },
})

const Headline = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: { base: '32px', md: '44px' },
    fontWeight: 700,
    lineHeight: 1.1,
    letterSpacing: '-0.02em',
    margin: 0,
  },
})

const Body = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: { base: '16px', md: '18px' },
    lineHeight: 1.55,
    color: 'rgba(255, 255, 255, 0.82)',
    maxWidth: '560px',
    margin: 0,
  },
})

const Actions = styled('div', {
  base: {
    marginTop: '8px',
    display: 'flex',
    flexDirection: { base: 'column', sm: 'row' },
    gap: '12px',
  },
})

const PrimaryButton = styled('a', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    fontWeight: 600,
    color: 'app.fg',
    backgroundColor: '#fff',
    paddingX: '24px',
    paddingY: '14px',
    borderRadius: 'pill',
    textDecoration: 'none',
    transition: 'transform 160ms, box-shadow 160ms',
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.12)',
    _hover: {
      transform: 'translateY(-1px)',
      textDecoration: 'none',
      boxShadow: '0 6px 18px rgba(15, 23, 42, 0.18)',
    },
  },
})

const SecondaryButton = styled('a', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    fontWeight: 600,
    color: '#fff',
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
    paddingX: '24px',
    paddingY: '14px',
    borderRadius: 'pill',
    border: '1px solid rgba(255, 255, 255, 0.32)',
    textDecoration: 'none',
    transition: 'background-color 160ms',
    _hover: {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      textDecoration: 'none',
    },
  },
})

export {
  Section,
  Inner,
  Eyebrow,
  Headline,
  Body,
  Actions,
  PrimaryButton,
  SecondaryButton,
}
